import { ModalService } from '../../../shared/utils/services/modal.service';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { BossServicesService } from '../../../shared/services/boss-services.service';
import { AllServicesComponent } from '../../../shared/ui/all-services/all-services.component';

@Component({
  selector: 'qwiko-services',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslocoModule,
    AllServicesComponent,
  ],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
})
export class ServicesComponent {
  services = inject(BossServicesService);
  modalService = inject(ModalService);
}
